"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddBrandPromoBodyToJSON = exports.AddBrandPromoBodyFromJSONTyped = exports.AddBrandPromoBodyFromJSON = void 0;
function AddBrandPromoBodyFromJSON(json) {
    return AddBrandPromoBodyFromJSONTyped(json, false);
}
exports.AddBrandPromoBodyFromJSON = AddBrandPromoBodyFromJSON;
function AddBrandPromoBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'brand': json['brand'],
        'promo': json['promo'],
    };
}
exports.AddBrandPromoBodyFromJSONTyped = AddBrandPromoBodyFromJSONTyped;
function AddBrandPromoBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'brand': value.brand,
        'promo': value.promo,
    };
}
exports.AddBrandPromoBodyToJSON = AddBrandPromoBodyToJSON;
